import commonFunctions from '@/mixins/common';
import NotificationPreferenceService from '@/services/notification-preference.service';

export default {
  mixins: [commonFunctions],
  data() {
    return {
      debugLog: false,
      covid19OverdueReminderUUID: 'covid19_overdue_reminder-74f4fa63-dab4-4d5b-8d48-ac04849bf189',
      covid19HealthReminderUUID: 'covid19_health_reminders-bf7bc960-7524-4433-ab48-47189569184e',
      learn2GoOverdueReminderUUID: 'learn2go_overdue_reminder-b01ade8f-491f-4180-956d-725cebeaf868',
    };
  },
  methods: {
    /**
     * This takes in the member record and attempts to return a string of the time of day
     * @param member
     * @returns {null}
     */
    getMemberHealthReminderTime(member) {
      let timeOfDay = null;
      this.log('NotificationPreferenceMixin : getMemberHealthReminderTime', 'member', member);
      if (member) {
        const healthNotificationPreference = member.attributes.health_notification_preference;
        if (healthNotificationPreference && healthNotificationPreference.enabled === true) {
          const minutesSinceMidnight = healthNotificationPreference.minutes_since_midnight;
          this.log('NotificationPreferenceMixin : getMemberHealthReminderTime', 'healthNotificationPreference', healthNotificationPreference);
          this.log('NotificationPreferenceMixin : getMemberHealthReminderTime', 'minutesSinceMidnight', minutesSinceMidnight);
          timeOfDay = this.convertMinutesToTime(minutesSinceMidnight);
        } else {
          timeOfDay = 'Disabled';
        }
      }
      return timeOfDay;
    },
    /**
     * This takes in the minutes since midnight and converts it to am / pm time string
     * @param minutes
     * @returns {null}
     */
    convertMinutesToTime(minutesSinceMidnight) {
      let timeOfDayString = null;
      let timeSuffix = 'am';
      this.log('NotificationPreferenceMixin : convertMinutesToTime', 'minutes', minutesSinceMidnight);
      if (minutesSinceMidnight) {
        let hours = Math.floor(minutesSinceMidnight / 60);
        const minutes = (minutesSinceMidnight % 60);
        let minutesLabel = `${minutes}`;
        if (minutes < 10) {
          minutesLabel = `0${minutesLabel}`;
        }
        this.log('NotificationPreferenceMixin : convertMinutesToTime', 'hours', hours);
        this.log('NotificationPreferenceMixin : convertMinutesToTime', 'minutes', minutes);

        if (hours >= 12) {
          timeSuffix = 'pm';
          hours -= 12;
        }

        timeOfDayString = `${hours}:${minutesLabel} ${timeSuffix}`;
      }
      return timeOfDayString;
    },
    getHealthReminderPreferenceFromList(preferences) {
      if (preferences) {
        this.log('NotificationPreferenceMixin : getHealthReminderPreferenceFromList', 'preferences', preferences);
      }
    },
    findHealthNotification(polyId, polyModel) {
      const secondsSinceEpoch = Math.round(Date.now() / 1000);
      const params = {
        'query[notification_preferable_id_eq]': polyId,
        'query[notification_preferable_type_eq]': polyModel,
        'query[type_uuid_eq]': this.covid19HealthReminderUUID,
        'query[archived_eq]': false,
        timestamp: secondsSinceEpoch,
      };
      this.log('NotificationPreferencesMixin findHealthNotification', 'params', params);
      return NotificationPreferenceService.index(params).then((response) => {
        let preference = null;
        const preferences = response.data;
        this.log('NotificationPreferencesMixin NotificationPreferencesService.index', 'response', response);
        if (preferences.length > 0) {
          // eslint-disable-next-line prefer-destructuring
          preference = preferences[0];
        }
        return preference;
      });
    },
    findOverdueNotification(polyId, polyModel, applicationType = process.env.VUE_APP_APPLICATION_TYPE) {
      const secondsSinceEpoch = Math.round(Date.now() / 1000);
      let params = {};
      if (applicationType === 'COVID-19') {
        params = {
          'query[notification_preferable_id_eq]': polyId,
          'query[notification_preferable_type_eq]': polyModel,
          'query[type_uuid_eq]': this.covid19OverdueReminderUUID,
          'query[archived_eq]': false,
          timestamp: secondsSinceEpoch,
        };
      } else {
        params = {
          'query[notification_preferable_id_eq]': polyId,
          'query[notification_preferable_type_eq]': polyModel,
          'query[type_uuid_eq]': this.learn2GoOverdueReminderUUID,
          'query[archived_eq]': false,
          timestamp: secondsSinceEpoch,
        };
      }
      this.log('NotificationPreferencesMixin findOverdueNotification', 'params', params);
      return NotificationPreferenceService.index(params).then((response) => {
        let preference = null;
        const preferences = response.data;
        this.log('NotificationPreferencesMixin findOverdueNotification NotificationPreferencesService.index', 'response', response);
        if (preferences.length > 0) {
          // eslint-disable-next-line prefer-destructuring
          preference = preferences[0];
        }
        return preference;
      });
    },
    findAllNotificationPreferences(polyId, polyModel) {
      const secondsSinceEpoch = Math.round(Date.now() / 1000);
      const params = {
        'query[notification_preferable_id_eq]': polyId,
        'query[notification_preferable_type_eq]': polyModel,
        'query[archived_eq]': false,
        timestamp: secondsSinceEpoch,
      };
      this.log('NotificationPreferencesMixin findAllNotificationPreferences', 'params', params);
      return NotificationPreferenceService.index(params).then((response) => {
        const preferences = response.data;
        this.log('NotificationPreferencesMixin findAllNotificationPreferences NotificationPreferencesService.index', 'response', response);
        return preferences;
      });
    },
  },
};
